import { useEffect } from 'react';

/**
 * SEO Component for dynamic meta tag management
 * Usage: <SEO title="Page Title" description="Page description" />
 */
const SEO = ({
    title = "Ristrutturazioni e Impianti Elettrici Roma | Tecno Domus 360",
    description = "Ristrutturazioni bagni, cucine e appartamenti a Roma. Impianti elettrici certificati, domotica e automazione. Preventivi gratuiti. ☎️ 328 8487837",
    keywords = "ristrutturazione bagno roma, ristrutturazione appartamento roma, impianti elettrici roma, elettricista roma",
    ogImage = "https://tecnodomus360.it/og-image.jpg",
    canonical = "https://tecnodomus360.it/"
}) => {
    useEffect(() => {
        // Update document title
        document.title = title;

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', description);
        }

        // Update meta keywords
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
            metaKeywords.setAttribute('content', keywords);
        }

        // Update OG tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', title);

        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute('content', description);

        const ogImg = document.querySelector('meta[property="og:image"]');
        if (ogImg) ogImg.setAttribute('content', ogImage);

        const ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) ogUrl.setAttribute('content', canonical);

        // Update Twitter tags
        const twitterTitle = document.querySelector('meta[property="twitter:title"]');
        if (twitterTitle) twitterTitle.setAttribute('content', title);

        const twitterDesc = document.querySelector('meta[property="twitter:description"]');
        if (twitterDesc) twitterDesc.setAttribute('content', description);

        const twitterImg = document.querySelector('meta[property="twitter:image"]');
        if (twitterImg) twitterImg.setAttribute('content', ogImage);

        // Update canonical
        let linkCanonical = document.querySelector('link[rel="canonical"]');
        if (!linkCanonical) {
            linkCanonical = document.createElement('link');
            linkCanonical.setAttribute('rel', 'canonical');
            document.head.appendChild(linkCanonical);
        }
        linkCanonical.setAttribute('href', canonical);

    }, [title, description, keywords, ogImage, canonical]);

    return null; // This component doesn't render anything
};

export default SEO;
